export const config = {
    typeform: {
        getstarted:{
            US: "ekRFbggl",
            UK: "DPhKjiLE"
        }
    }
}